import * as React from 'react';
import { UserState } from '../../../interface/MyInterfaces';
import { VendorReportState, VendorProfile, VendorReportAction } from '../../../interface/VendorReportInterface';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import NewVendorTab1First from './NewVendorTab1First';
interface VendorProfileState {
    selectedVendorProfile?: VendorProfile;
}

class NewVendorProfilesTab extends React.Component<VendorReportState & UserState & VendorReportAction, VendorProfileState> {
    constructor(props) {
        super(props);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.VendorProfile !== undefined) {
            this.setState({
                selectedVendorProfile: nextProps.VendorProfile[0],
            });
        }
    }
    componentDidMount() {
        if (this.props.VendorProfile) {
            this.setState({ selectedVendorProfile: this.props.VendorProfile[0] });
        }
    }

    render() {
        let logoUni;
        //when report is shared the inital report display id is undefined which blocks the report from loading

        if (this.props.display_id) {
            try {
                logoUni = require(`../../../images/univ_logos/${this.props.display_id}.png`);
            }
            catch (err) {

            }
        }
        //console.log(this.props.ReportsConf);
        return <div className='firstTab tabcontents container-fluid'>
            <div className='row'>
                <div className="col-md-12">
                    <div className="bullets--before">
                        <div className="newVendorTitleDiv">
                            <h3>{this.props.agg ? `Vendor Profile Report for ${this.props.HomeState && this.props.HomeState.campusname}` : `${this.props.HomeState && this.props.HomeState.the_university && this.props.HomeState.the_university.charAt(0).toUpperCase() + this.props.HomeState.the_university.slice(1)} Vendor Profile Report`}</h3>
                            <div className="universityLogo">
                                {logoUni &&
                                    <img height='60px'
                                        src={String(logoUni)}
                                        alt='Logo'></img>
                                }
                            </div>
                        </div>
                        <br />
                        <h4>{this.props.HomeState && this.props.HomeState.title && this.props.HomeState.title}</h4>
                        {this.props.display_id == "99007319" && <div>
                            <h2><b style={{ color: "red" }}>Synthetic data for demonstration purposes only</b></h2>
                        </div>}
                        <div>
                            {this.props.VendorReport_Tab1 && this.props.VendorReport_Tab1.top_description}
                        </div>
                        <p>
                            {this.props.HomeState && this.props.HomeState.campusname == "CPUPC/IRIS Universities" && "CPUPC comprises Texas public general academic universities, system offices, health-related institutions, and the three two-year state colleges in the Houston area. "}
                            {this.props.ReportsConf && this.props.ReportsConf.methodology_text}
                        </p>
                    </div>
                </div>
            </div>

            {this.props.HomeState && this.props.BVDMatchRates && this.props.VendorProfilesByYear && this.props.VendorReport_Tab1 && this.props.selected_year &&
                <NewVendorTab1First
                    sliderChange={this.props.sliderChange}
                    display_id={this.props.display_id}
                    selected_year={this.props.selected_year}
                    university={this.props.HomeState && this.props.HomeState.campusname}
                    HomeState={this.props.HomeState}
                    VendorProfilesByYear={this.props.VendorProfilesByYear}
                    BVDMatchRates={this.props.BVDMatchRates}
                    minYear={this.props.TrendsPar ? this.props.TrendsPar[0].min_year : 0}
                    maxYear={this.props.TrendsPar ? this.props.TrendsPar[0].max_year : 0}
                    VendorReport_Tab1={this.props.VendorReport_Tab1}
                    vendorRelease={this.props.vendorRelease}
                />
            }
            <div className="bullets--before bottom--description" >
                <p>
                    {this.props.VendorReport_Tab1 && this.props.VendorReport_Tab1.bottom_description}
                </p>
            </div>
        </div>;
    }
}

export default withUserActionTracker(NewVendorProfilesTab, "Vendor Profile Report", "viewed Vendor Profiles Tab");